
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'

import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'settings',
components: {
Group,
GroupTitle,
XSwitch,
XNumber,
XButton,
Radio,
PopupRadio,
Cell,
Box,
},
data: function () {
return {
showLanguageOption: false,
}
},
computed: {
...mapState(['maxThreads', 'supportThreads', 'supportSimd', 'supportRelaxedSimd']),
...mapState('ai', ['fullEngine']),
...mapState('settings', [
'language',
'thinkTimeOption',
'turnTime',
'matchTime',
'maxDepth',
'maxNodes',
'strength',
'nbest',
'threads',
'pondering',
'configIndex',
'candRange',
'boardSize',
'rule',
'aiThinkBlack',
'aiThinkWhite',
'clickCheck',
'showCoord',
'showAnalysis',
'showDetail',
'showPvEval',
'showIndex',
'showLastStep',
'showWinline',
'showForbid',
'boardStyle',
'hashSize',
]),
languageOptions() {
return [
{ "key": "zh-CN", "value": "简体中文" },
{ "key": "zh-TW", "value": "繁體中文" },
{ "key": "en", "value": "English" },
{ "key": "ko", "value": "한국어" },
{ "key": "ja", "value": "日本語" },
{ "key": "vi", "value": "Tiếng Việt" },
{ "key": "ru", "value": "Русский" }
]
},
thinkTimeOptions() {
return [
{ key: 1, value: this.$t('setting.thinking.fast') },
{ key: 2, value: this.$t('setting.thinking.slow') },
{ key: 3, value: this.$t('setting.thinking.analysis') },
{ key: 0, value: this.$t('setting.thinking.custom') },
]
},
configIndexOptions() {
if (this.fullEngine) {
return [
{ key: 0, value: this.$t('setting.thinking.config.mix9svq') },
{ key: 1, value: this.$t('setting.thinking.config.220723') },
{ key: 2, value: this.$t('setting.thinking.config.210901') },
]
} else {
return [
{ key: 1, value: this.$t('setting.thinking.config.220723') },
{ key: 2, value: this.$t('setting.thinking.config.210901') },
]
}
},
candRangeOptions() {
return [
{ key: 0, value: this.$t('setting.thinking.candrange.square2') },
{ key: 1, value: this.$t('setting.thinking.candrange.square2line3') },
{ key: 2, value: this.$t('setting.thinking.candrange.square3') },
{ key: 3, value: this.$t('setting.thinking.candrange.square3line4') },
{ key: 4, value: this.$t('setting.thinking.candrange.square4') },
{ key: 5, value: this.$t('setting.thinking.candrange.fullboard') },
]
},
hashSizeOptions() {
return [
{ key: 128, value: '128MB' },
{ key: 256, value: '256MB' },
{ key: 512, value: '512MB' },
{ key: 1024, value: '1GB' },
{ key: 1536, value: '1.5GB' },
]
},
ruleOptions() {
return [
{ key: 0, value: this.$t('setting.board.rule.gomoku') },
{ key: 1, value: this.$t('setting.board.rule.standard') },
{ key: 2, value: this.$t('setting.board.rule.renju') },
{ key: 5, value: this.$t('setting.board.rule.swap1') },
]
},
clickCheckOptions() {
return [
{ key: 0, value: this.$t('setting.board.clickCheck.direct') },
{ key: 1, value: this.$t('setting.board.clickCheck.confirm') },
{ key: 2, value: this.$t('setting.board.clickCheck.slide') },
]
},
showPvEvalOptions() {
return [
{ key: 0, value: this.$t('setting.board.showPvEval.none') },
{ key: 1, value: this.$t('setting.board.showPvEval.eval') },
{ key: 2, value: this.$t('setting.board.showPvEval.winrate') },

]
},
languageValue: {
get() {
return this.language
},
set(v) {
this.setValue({ key: 'language', value: v })
},
},
thinkTimeSelected: {
get() {
return this.thinkTimeOption
},
set(v) {
this.setValue({ key: 'thinkTimeOption', value: v })
},
},
turnTimeInSecond: {
get() {
return Math.floor(this.turnTime / 500) / 2
},
set(v) {
this.setValue({ key: 'turnTime', value: v * 1000 })
},
},
matchTimeInSecond: {
get() {
return Math.floor(this.matchTime / 1000)
},
set(v) {
this.setValue({ key: 'matchTime', value: v * 1000 })
},
},
maxDepthValue: {
get() {
return this.maxDepth
},
set(v) {
this.setValue({ key: 'maxDepth', value: v })
},
},
maxNodeValue: {
get() {
return this.maxNodes / 1000000
},
set(v) {
this.setValue({ key: 'maxNodes', value: Math.ceil(v * 1000000) })
},
},
handicapValue: {
get() {
return 100 - this.strength
},
set(v) {
this.setValue({ key: 'strength', value: 100 - v })
},
},
nbestValue: {
get() {
return this.nbest
},
set(v) {
this.setValue({ key: 'nbest', value: v })
},
},
threadsValue: {
get() {
return this.threads
},
set(v) {
this.setValue({ key: 'threads', value: v })
},
},
ponderingValue: {
get() {
return this.supportThreads ? this.pondering : false
},
set(v) {
this.setValue({ key: 'pondering', value: v })
},
},
configIndexValue: {
get() {
return this.configIndex
},
set(v) {
this.setValue({ key: 'configIndex', value: v })
},
},
candRangeValue: {
get() {
return this.candRange
},
set(v) {
this.setValue({ key: 'candRange', value: v })
},
},
hashSizeValue: {
get() {
return this.hashSize
},
set(v) {
this.setValue({ key: 'hashSize', value: v })
},
},
boardSizeValue: {
get() {
return this.boardSize
},
set(v) {
this.setValue({ key: 'boardSize', value: v })
},
},
ruleValue: {
get() {
return this.rule
},
set(v) {
this.setValue({ key: 'rule', value: v })
this.checkForbid()
},
},
aiThinkBlackValue: {
get() {
return this.aiThinkBlack
},
set(v) {
this.setValue({ key: 'aiThinkBlack', value: v })
},
},
aiThinkWhiteValue: {
get() {
return this.aiThinkWhite
},
set(v) {
this.setValue({ key: 'aiThinkWhite', value: v })
},
},
clickCheckValue: {
get() {
return this.clickCheck
},
set(v) {
this.setValue({ key: 'clickCheck', value: v })
},
},
showCoordValue: {
get() {
return this.showCoord
},
set(v) {
this.setValue({ key: 'showCoord', value: v })
},
},
showAnalysisValue: {
get() {
return this.showAnalysis
},
set(v) {
this.setValue({ key: 'showAnalysis', value: v })
},
},
showDetailValue: {
get() {
return this.showDetail
},
set(v) {
this.setValue({ key: 'showDetail', value: v })
},
},
showPvEvalValue: {
get() {
return this.showPvEval
},
set(v) {
this.setValue({ key: 'showPvEval', value: v })
},
},
showIndexValue: {
get() {
return this.showIndex
},
set(v) {
this.setValue({ key: 'showIndex', value: v })
},
},
showLastStepValue: {
get() {
return this.showLastStep
},
set(v) {
this.setValue({ key: 'showLastStep', value: v })
},
},
showWinlineValue: {
get() {
return this.showWinline
},
set(v) {
this.setValue({ key: 'showWinline', value: v })
},
},
showForbidValue: {
get() {
return this.showForbid
},
set(v) {
this.setValue({ key: 'showForbid', value: v })
},
},
boardColor: {
get() {
return this.boardStyle.boardColor
},
set(v) {
this.setBoardStyle({ key: 'boardColor', value: v })
},
},
lastStepColor: {
get() {
return this.boardStyle.lastStepColor
},
set(v) {
this.setBoardStyle({ key: 'lastStepColor', value: v })
},
},
winlineColor: {
get() {
return this.boardStyle.winlineColor
},
set(v) {
this.setBoardStyle({ key: 'winlineColor', value: v })
},
},
bestMoveColor: {
get() {
return this.boardStyle.bestMoveColor
},
set(v) {
this.setBoardStyle({ key: 'bestMoveColor', value: v })
},
},
thoughtMoveColor: {
get() {
return this.boardStyle.thoughtMoveColor
},
set(v) {
this.setBoardStyle({ key: 'thoughtMoveColor', value: v })
},
},
lostMoveColor: {
get() {
return this.boardStyle.lostMoveColor
},
set(v) {
this.setBoardStyle({ key: 'lostMoveColor', value: v })
},
},
},
methods: {
...mapMutations('settings', ['setValue', 'setBoardStyle']),
...mapActions('settings', ['clearCookies']),
...mapActions('ai', ['checkForbid']),
reset() {
this.clearCookies()
location.reload()
},
},
watch: {},
}
